import React from "react"
import Layout from "../components/Layout"
import "../css/projects/py_proj1.css"
import { Link } from "gatsby"
import { FaCode } from "react-icons/fa"
import SEO from "../components/SEO"
import Particle8 from "../components/Particle8"

const Py_proj2 = () => {
  return (
    <Layout>
      <SEO title="GPS-Track The Route" description="Awesome python project" />
      <Particle8></Particle8>
      <h6>s</h6>

      <section className="noSelect">
        <Link to="/pythonprojectcard/">
          <button type="button" className="back-btn noSelect">
            <span>{"<"}= More Projects</span>
          </button>
        </Link>
      </section>

      <section className="proj-name-wrap noSelect">
        <div className="pyt-img-2">
          <div className="py-1-heading">
            <h1>GPS-Track The Route</h1>
          </div>
        </div>
        <div className="git">
          <a
            href="https://github.com/arpitsomani8/Python-Programming-Projects/tree/master/GPS-Track%20The%20Route"
            target="_blank"
            rel="noopener noreferrer"
            title="Github code"
          >
            <FaCode className="git-btn"></FaCode>
          </a>
        </div>

        <div className="proj-1">
          <div className="p1">
            <h3>Concept Behind It :</h3>
            <p>
              GPS- Global positioning system
              <br />
              <br />
              In this we have values of latitudes and longitudes of a path.
              <br /> We are tracking the the path of that person , as how many
              places he had visited.
              <br />
              It's very useful and it's a very important thing in the dilevery
              system, that the person has delevired the item or not, <br />
              and if not, where he is actually roaming ...
              <br />
              <br />
              We are doing this all by python.
              <br />
              we will get a html file in last, which will have the mapping of
              the complete track.
              <br />I have used a colourful marking of starting and ending
              points as well as for the route.
              <br />
            </p>

            <h3>Skills Behind It :</h3>
            <div className="py-skill-1">
              <button type="button" className="btn-py-1" disabled>
                <span>Gmplot</span>
              </button>
              <button type="button" className="btn-py-1" disabled>
                <span> CSV</span>
              </button>
              <button type="button" className="btn-py-1" disabled>
                <span>Python</span>
              </button>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default Py_proj2
